import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { Grid, Box, Typography, TextField, InputLabel, Dialog, DialogContent, DialogActions, Button } from "@material-ui/core";
import { LoadingButton } from '@mui/lab';
import "./styles.scss";
import { logout, postLogin } from '../../../redux/actions/auth';
import { getBook, getStory, getStoryAsLazy, getStoryChapters } from '../../../redux/actions/buddyBooks';
import { getSavedSession, getStudent } from '../../../redux/actions/students';
import _ from 'lodash';
import { getSettings } from '../../../redux/actions/settings';
import objectiveedLogo from "../../../assets/images/OBJECTIVEED-Logo-Horizontal-1.png"
import buddyBooksLogo from "../../../assets/images/BB-logo-oed.png"
import { DialogTitle, IconButton, InputAdornment, Link } from '@mui/material';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { deviceInfo } from '../../../utils/utility';

let gotBook = false;
let dispatchSavedSession = false;
let dispatchStory = false;
let isIPhone = /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
// let loading = false;

function Login({ dispatch, auth, getStoryFail }) {
    //HOOKS
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [errMsg, setErrMsg] = useState('');
    let history = useHistory();
    const [isMobile, setIsMobile] = useState(false);
    const [browserSupported, setBrowserSupported] = useState(false);
    const [browserModal,setBrowserModal]=useState(false)
    const [helpModal, setHelpModal] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    const { isAuthenticated, isError, errorMessage } = auth;

    const onSubmit = (data) => {
        if (data) {
            dispatch(logout());
            setErrMsg('');
            dispatch(postLogin(data));
            setLoading(true);
            gotBook = false;
        } else {
            setErrMsg('Incorrect Password')
        }
    }

    //CDM
    useEffect(() => {
        const {mobile,browser,isIpad} = deviceInfo()
        const isIos = isIpad || isIPhone
    
        const currentURL = window.location.href;
            
        const iosBuildURL = process.env.REACT_APP_IOS_BUILD_URL;
        const nonIOSBuildURL = process.env.REACT_APP_NON_IOS_BUILD_URL;

        console.log("Ios Build URL: ",iosBuildURL)
        console.log("Non Ios Build URL: ",nonIOSBuildURL)
            
        // Function to perform the redirect
        const redirectBasedOnDevice = () => {
            if (isIos && !currentURL.includes(iosBuildURL)) {
                    window.location.href = iosBuildURL;
                } else if (!isIos && !currentURL.includes(nonIOSBuildURL)) {
                    window.location.href = nonIOSBuildURL;
                }
                };
        
        if(iosBuildURL && nonIOSBuildURL){
            redirectBasedOnDevice();
        }

        navigator.mediaDevices.getUserMedia({ audio: true }).then(() => {
            console.log('permission success')
        }, () => {
            console.log('permission denied');
        });

        //clearing localStorage
        let keysToRemove = ["logged_user", "reporting_time", "book_id", "current_section"];

        for (let key of keysToRemove) {
            localStorage.removeItem(key);
        }

        if(mobile || !browser){
            setBrowserModal(true)
        }
    }, [])

    useEffect(() => {
        console.log("cdu isAuthen", isAuthenticated);
        if (isAuthenticated && loading) {
            setLoading(false);
            history.push('/book-page');
        }

        if (isError) {
            setLoading(false);
            setErrMsg(errorMessage);
        }

        if (getStoryFail) {
            setLoading(false);
        }

    }, [isError, isAuthenticated])

    return (
        <>
            <Box component="div" className="container">
                <Box component="div" className="innerContainer">
                        <img src={buddyBooksLogo} alt="logo" className='logo' />
                    <Typography component='div' variant='h6' className="loginHeader">
                        BuddyBooks Student Website
                    </Typography>
                    <img src={objectiveedLogo} alt="logo" className='objectiveEdLogo'/>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='formCont'>
                                <TextField
                                    className ="formFieldsCont"
                                    type="text"
                                    id="username"
                                    name="username"
                                    {...register('username', {
                                        required: {
                                            value: true,
                                            message: 'Incorrect Password'
                                        }
                                    })}
                                    label="Username"
                                    color='primary'
                                    variant="outlined"
                                />
                                <TextField
                                    className ="formFieldsCont"
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    name="password"
                                    {...register('password', {
                                        required: {
                                            value: true,
                                            message: 'Incorrect Password'
                                        }
                                    })}
                                    label="Password"
                                    color='primary'
                                    variant="outlined"
                                    InputProps={{
                                        endAdornment: (
                                          <InputAdornment position='end'>
                                            <IconButton
                                              aria-label='Toggle password visibility'
                                              onClick={()=>{setShowPassword(!showPassword)}}
                                            >
                                              {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                          </InputAdornment>
                                        ),
                                      }}
                                />
                            <div className='errorCont'>
                                {errors.password ?
                                    <Typography component='div' className='error'>{errors.password.message}</Typography> :
                                    (errMsg === 'Please log in at Platform.ObjectiveEd.com' ?
                                    <Typography component='div' className='error'>
                                        Please log in at <Link className='error' href='https://platform.objectiveed.com/login' underline='hover'>Platform.ObjectiveEd.com</Link>
                                    </Typography> :
                                    <Typography component='div' className='error'>
                                        {errMsg}
                                    </Typography>)
                                }
                            </div>

                            <div className='buttonCont'>
                                <LoadingButton
                                    type="submit"
                                    id='loginBtn'
                                    variant="contained"
                                    small='true'
                                    className={loading ? "loadBtn" : "btn"}
                                    loading={loading}
                                    loadingPosition="center"
                                >
                                    <Typography htmlFor="username" className='label'>LOG IN</Typography>
                                </LoadingButton>
                            </div>
                        </div>
                    </form>
                    <Link href='#' underline='none' onClick={()=>{setHelpModal(true)}}>Where can I find my Username/Password?</Link>
                </Box>
                {(isMobile || !browserSupported) && <Dialog
                    open={browserModal}
                    onClose={() => { setBrowserModal(false) }}
                >
                    <DialogContent>
                        <Typography variant='subtitle1'>{isMobile ? "ObjectiveEd currently only supports use of BuddyBooks on PC, Mac, and Chromebook devices."
                            : `ObjectiveEd only currently supports use of BuddyBooks with the following browsers:
                                    Chrome, Edge, Safari.`}</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setBrowserModal(false) }} color='secondary'>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>}
                {
                    helpModal && <Dialog
                    open={helpModal}
                    onClose={()=>{ setHelpModal(false)}}>
                        <DialogTitle>
                        Where can I find my Username/Password?
                        </DialogTitle>
                        <DialogContent>
                        <Typography style={{textAlign:"center"}} variant='subtitle1'>Your username and password is set by your <br/> 
                            teacher/parent on the teacher/parent website, <br/> <br/> 
                            <Link underline='none' href='https://platform.objectiveed.com/login' target="_blank" rel="noopener noreferrer">
                                https://platform.objectiveed.com/login
                                </Link> 
                                </Typography>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={() => { setHelpModal(false) }} color='secondary'>
                            Close
                        </Button>
                    </DialogActions>
                    </Dialog>
                }
            </Box>
        </>
    )
}

const mapState = ({ platform: { auth, analysis: { book, getStoryFail, savedSessionResponse }, story, lazyStory } }) => {
    return {
        auth,
        book,
        story,
        lazyStory,
        getStoryFail,
        savedSessionResponse
    }
};

export default connect(mapState)(Login);
